/** ServiceNow's logo URL. Kept separate from `servicenow-ai`'s registration so
 * the MCP server spec can use it without registering the integration. */
export const ServiceNowAiIconUrl =
  "https://avatars.githubusercontent.com/u/6577392?s=200&v=4";
